var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVariablesTextEditorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.92 3.41989C20.38 2.86989 19.65 2.55988 18.87 2.59988L14.32 2.72989C13.63 2.74989 12.97 3.02989 12.47 3.50989L2.78999 12.9599C2.05999 13.6699 2.01999 14.8199 2.69999 15.5199L8.38999 21.3499C8.71999 21.6799 9.14999 21.8699 9.62999 21.8699H9.67999C10.15 21.8599 10.6 21.6599 10.95 21.3299L20.63 11.8799C21.13 11.3999 21.42 10.7499 21.46 10.0499L21.69 5.49989C21.73 4.70989 21.46 3.97989 20.92 3.42989V3.41989ZM19.96 9.95989C19.94 10.2699 19.81 10.5699 19.58 10.7899L9.89999 20.2499C9.79999 20.3499 9.68999 20.3699 9.63999 20.3699C9.58999 20.3699 9.51999 20.3699 9.45999 20.3099L3.77999 14.4699C3.67999 14.3699 3.70999 14.1699 3.83999 14.0299L13.52 4.57988C13.75 4.35988 14.04 4.22988 14.36 4.21988L18.91 4.08989C19.28 4.09989 19.61 4.20989 19.85 4.45989C20.09 4.70989 20.21 5.03989 20.2 5.40988L19.97 9.95989H19.96Z",
    fill: "var(--color-color7)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 5.25C15.26 5.25 14.25 6.26 14.25 7.5C14.25 8.74 15.26 9.75 16.5 9.75C17.74 9.75 18.75 8.74 18.75 7.5C18.75 6.26 17.74 5.25 16.5 5.25ZM16.5 8.25C16.09 8.25 15.75 7.91 15.75 7.5C15.75 7.09 16.09 6.75 16.5 6.75C16.91 6.75 17.25 7.09 17.25 7.5C17.25 7.91 16.91 8.25 16.5 8.25Z",
    fill: "var(--color-color7)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariablesTextEditorIcon);
export default __webpack_public_path__ + "static/media/variables-text-editor-icon.f29c04fa8cd0eaf6d6c9aa5576b04bd8.svg";
export { ForwardRef as ReactComponent };